export enum AnalyticActionEvent {
  PAGE_VIEW = 'page-view',
  PAGE_VIEW_BOUNCE = 'page-view-bounce',
  PAGE_VIEW_ABANDON = 'page-view-abandon',
  COMPLETED = 'completed'
}
